// @ts-nocheck
import React from "react";
import getMenuItems from "components/Menu/MenuItems";
import Page from "Pages/Page/Page";
import { Routes, Route, Navigate } from "react-router-dom";
import useAccount from "classes/Accounts/hooks/useAccount";
import ServError from "components/ServError/ServError";
import useTemplate from "hooks/useTemplate";
import { PICTOS_URL } from "includes/paths";

export default function RoutesWrapper(props) {
	const { isAdmin, getSettings, isSup } = useAccount();
	const { template } = useTemplate();
	const { platform, curPage } = props;
	const { isMenuOpen, setIsMenuOpen, setLangCode } = props;

	function isMenuDisabled(menu) {
		if (menu.settingName && !getSettings(menu.settingName)) return true;
		if (menu.role && isSup(menu.role) < 0) return true;
		if (menu.platform === "admin" && !isAdmin()) return true;
		if (menu.appFunction && template && template.getAppFunctions()) {
			let func = template.getAppFunction(menu.appFunction);
			if (!func && platform !== "admin") return true;
		}
		return false;
	}

	function isItemDisabled(item) {
		if (item.settingName && !getSettings(item.settingName)) return true;
		if (item.role && isSup(item.role) < 0) return true;
		if (item.platform === "admin" && !isAdmin()) return true;
		if (item.appFunction && template && template.getAppFunctions()) {
			let func = template.getAppFunction(item.appFunction);
			if (!func && platform !== "admin") return true;
		}
		return false;
	}

	function getCustomName(item) {
		let ret = { ...item };
		if (item.appMenu && template && template.getMenus) {
			let menu = template.getMenus(item.appMenu);
			if (menu) {
				if (menu.title?.length) ret.title = menu.title;
				if (menu.iconName?.length)
					ret.icon = PICTOS_URL + encodeURIComponent(menu.iconName);
			}
		}
		return ret;
	}

	const genGroupRoutes = (group) => {
		let ret = [];

		if (isMenuDisabled(group)) return false;

		let custom_group = getCustomName(group);

		const pageElement = (
			<Page
				{...custom_group}
				setLangCode={setLangCode}
				items={group.items}
				curPage={curPage}
				isAdmin={isAdmin}
				curPlatform={platform}
				isMenuOpen={isMenuOpen}
				setIsMenuOpen={setIsMenuOpen}
			/>
		);

		const paths = group.paths ? group.paths : [group.url];
		const pathsArr = Array.isArray(paths) ? paths : [paths];
		pathsArr.forEach((p) => {
			ret.push(
				<Route
					path={p}
					key={group.url + p}
					element={pageElement}
				/>
			);
		});

		let inner_routes = genRoutes(group.items);
		if (inner_routes) ret.push(...inner_routes);
		return ret;
	};

	const genPageRoutes = (page) => {
		if (isItemDisabled(page)) return false;

		let custom_page = getCustomName(page);

		const pageElement = (
			<Page
				{...custom_page}
				setLangCode={setLangCode}
				isAdmin={isAdmin}
				curPlatform={platform}
				isMenuOpen={isMenuOpen}
				setIsMenuOpen={setIsMenuOpen}
			/>
		);

		const paths = page.paths ? page.paths : [page.url];
		const pathsArr = Array.isArray(paths) ? paths : [paths];
		// In v6, exact is default. For non-exact routes, append /*
		const suffix = page.exact === false ? "/*" : "";

		return pathsArr.map((p) => (
			<Route
				path={p + suffix}
				key={page.url + p}
				element={pageElement}
			/>
		));
	};

	const genRoutes = (force_items) => {
		let ret = [];

		let items = getMenuItems();
		if (force_items) items = force_items;
		if (!items || !Array.isArray(items)) return ret;
		items.forEach((item) => {
			if (item.items) {
				let inner_routes = genGroupRoutes(item);
				if (inner_routes) ret.push(...inner_routes);
			} else {
				let routes = genPageRoutes(item);
				if (Array.isArray(routes)) ret.push(...routes);
				else if (routes) ret.push(routes);
			}
		});
		return ret.filter((a) => a);
	};

	const routes = genRoutes();

	return (
		<div
			id="main-cont"
			className={
				"w-100 h-100 content" +
				(["", "/", "/home"].indexOf(curPage) === -1 ? "" : " p-0")
			}
		>
			<Routes>
				<Route path="/fr-FR" element={<Navigate to="/" replace />} />
				<Route path="/fr-FR/" element={<Navigate to="/" replace />} />
				<Route path="/en-EN" element={<Navigate to="/" replace />} />
				<Route path="/en-EN/" element={<Navigate to="/" replace />} />
				{routes}
				<Route path="*" element={<ServError />} />
			</Routes>
		</div>
	);
}
